// src/utils/flats.js
export function getAllFlatsFromBlocks(blocks = []) {
    const labels = [];
    for (const b of blocks) {
        // Ground
        if (b.hasGround && b.groundFlatsCount > 0) {
            for (let i = 0; i < b.groundFlatsCount; i++) {
                const idx = (b.groundIndexStart ?? 1) + i;
                const width = b.groundIndexWidth ?? 2;
                labels.push(`${b.name}-${b.groundLabel}${String(idx).padStart(width, "0")}`);
            }
        }
        // Upper floors
        for (let f = 1; f <= (b.floors || 0); f++) {
            for (let i = 0; i < (b.flatsPerFloor || 0); i++) {
                const idx = (b.upperIndexStart ?? 1) + i;
                const width = (b.upperIndexWidth ?? 2);
                labels.push(`${b.name}-${f}${String(idx).padStart(width, "0")}`);
            }
        }
    }
    return labels.sort();
}